var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImageFrame = function SvgImageFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0h-14A2.503 2.503 0 0 0 0 2.5v14A2.503 2.503 0 0 0 2.5 19h14a2.503 2.503 0 0 0 2.5-2.5v-14A2.503 2.503 0 0 0 16.5 0zM18 16.5a1.5 1.5 0 0 1-1.5 1.5h-14A1.5 1.5 0 0 1 1 16.5v-1.703l9.95-5.4a3.248 3.248 0 0 1 3.1 0L18 11.542V16.5zm0-6.096-3.473-1.885a4.243 4.243 0 0 0-4.054 0L1 13.659V2.5A1.5 1.5 0 0 1 2.5 1h14A1.5 1.5 0 0 1 18 2.5v7.904zM5.5 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
  })));
};

export default SvgImageFrame;